<div class="flex flex-col">
  <mat-label class="flex flex-row items-center gap-2">
    {{ label | translate }}
    <span *ngIf="required && label">*</span>
    <app-icon
      *ngIf="infoTooltip"
      class="cursor-pointer"
      [matTooltip]="infoTooltip | translate"
      iconName="info"
      size="sm"
      fill="#1f5792"
      matTooltipPosition="above"></app-icon>
  </mat-label>
  <mat-form-field class="w-full">
    <mat-select
      [value]="value"
      (selectionChange)="onSelectChange($event.value)"
      [placeholder]="placeholder | translate"
      [panelClass]="panelClass">
      <mat-option *ngFor="let option of options" [value]="option.id ?? option.key">
        <div class="flex flex-row items-center gap-4">
          <app-icon size="md" iconName="{{option.name}}"></app-icon>
          <span>{{option.name}}</span>
        </div>
      </mat-option>
    </mat-select>
    <div class="mr-4" matSuffix>
      <app-icon size="md" *ngIf="value" iconName="{{CurrencyEnum[value]}}"></app-icon>
    </div>
  </mat-form-field>

  <mat-error flowValidationErrors *ngIf="control?.invalid && control?.touched"></mat-error>
</div>
